<runtime-editor-node-dialog rte="17D"></runtime-editor-node-dialog>